import React from "react";
import logo1 from "../../Images/22b9a3c2c78f7f6865685ff8b3e0973f-removebg-preview 1.png";
import logo2 from "../../Images/image 8.png";
import logo3 from "../../Images/image 9.png";
import logo4 from "../../Images/image 10.png";
import logo5 from "../../Images/image 11.png";
import "./WinnersHome.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
const WinnersClient = ({ center }) => {
  var settings = {
    autoplay: true,
    dots: false,
    infinite: true,
    autoplayspeed: 1000,
    slidesToShow: 5,
    slidesToScroll: 1,
   responsive: [
      {
        breakpoint: 1199, 
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 599, 
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 499, 
        settings: {
          slidesToShow: 1,
        },
      },
      
    ],
  };
  return (
    <>
      <div className="winners_client_wrapper">
        <div className="winners_client_div">
          <h1
            style={{
              textAlign: `${center} `,
            }}
            className="search_cities_head"
          >
            Our Satisfied Clients
          </h1>
          <div 
          // className="client_divs_wrapper"
          className="mt-4"
          >
          <Slider {...settings}>
          {[logo1, logo2, logo3, logo4, logo5].map((e) => {
              return (
                <>
                  <div className="client_logo_div">
                    <img src={e} />
                  </div>
                </>
              );
            })}
          </Slider>

          </div>
        </div>
      </div>
    </>
  );
};

export default WinnersClient;
